import { Region } from '@moonpig/web-core-types'
import { DateTime } from 'luxon'
import { logger } from '@moonpig/web-core-monitoring'

export type FormattedReminderDate = {
  day: number
  month: string
}

export const formatReminderDate = (
  nextDate: string,
  storeId: Region,
): FormattedReminderDate | null => {
  const reminderDate = DateTime.fromISO(nextDate)

  if (!reminderDate.isValid) {
    logger.fixToday('Invalid date passed into reminder mission button', {
      nextDate,
    })
    return null
  }

  const monthLocale = storeId === 'nl' ? 'nl' : 'en-GB'

  return {
    day: reminderDate.day,
    month: reminderDate.toFormat('MMM', { locale: monthLocale }),
  }
}
